import { createIcon } from '@chakra-ui/icons';

export const DirectAssignment = createIcon({
  displayName: 'DirectAssignment',
  viewBox: '0 0 48 48',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
      <g id="Document-Checklist-Pile--Streamline-Ux.svg">
        <path
          id="Vector"
          d="M24.0002 43.0077C34.498 43.0077 43.0082 34.4975 43.0082 23.9997C43.0082 13.5019 34.498 4.9917 24.0002 4.9917C13.5024 4.9917 4.99219 13.5019 4.99219 23.9997C4.99219 34.4975 13.5024 43.0077 24.0002 43.0077Z"
          fill="#FDE9C8"
        />
        <path
          id="Vector_2"
          d="M22.561 40.4235C25.4899 40.4235 27.8643 40.0673 27.8643 39.628C27.8643 39.1887 25.4899 38.8325 22.561 38.8325C19.6321 38.8325 17.2578 39.1887 17.2578 39.628C17.2578 40.0673 19.6321 40.4235 22.561 40.4235Z"
          fill="#F1CA89"
        />
        <path
          id="Vector_3"
          d="M20.8754 5.66869L15.0817 27.5228C14.9928 27.858 15.1924 28.2016 15.5276 28.2905L31.6148 32.5553C31.9499 32.6442 32.2936 32.4445 32.3824 32.1094L38.1761 10.2553C38.265 9.92017 38.0653 9.57645 37.7302 9.48764L21.643 5.22277C21.3079 5.13395 20.9642 5.33358 20.8754 5.66869Z"
          fill="white"
          stroke="#453924"
          strokeWidth="0.48"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M23.9872 7.23853L8.05222 12.0411C7.72029 12.1411 7.5323 12.4913 7.63233 12.8233L14.1565 34.4705C14.2565 34.8025 14.6067 34.9905 14.9387 34.8904L30.8736 30.0879C31.2056 29.9878 31.3936 29.6377 31.2935 29.3057L24.7694 7.65842C24.6693 7.32649 24.3191 7.1385 23.9872 7.23853Z"
          fill="white"
          stroke="#453924"
          strokeWidth="0.48"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_5"
          d="M14.7191 12.0514L13.3215 34.6172C13.3001 34.9632 13.5633 35.2611 13.9093 35.2825L30.5204 36.3113C30.8664 36.3327 31.1643 36.0696 31.1857 35.7236L32.5833 13.1578C32.6047 12.8117 32.3416 12.5138 31.9956 12.4924L15.3845 11.4636C15.0384 11.4422 14.7406 11.7053 14.7191 12.0514Z"
          fill="white"
          stroke="#453924"
          strokeWidth="0.48"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_6"
          d="M17.6328 22.2189L18.2885 22.9654L20.406 20.8398"
          stroke="#453924"
          strokeWidth="0.48"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_7"
          d="M21.1172 22.7021L21.4308 23.0666C21.4805 23.1244 21.5411 23.1718 21.6091 23.2061C21.6772 23.2404 21.7513 23.2611 21.8273 23.2668C21.9033 23.2725 21.9796 23.2631 22.052 23.2393C22.1244 23.2155 22.1914 23.1776 22.2491 23.1279L22.6136 22.8148C22.6713 22.765 22.7383 22.7272 22.8107 22.7034C22.8831 22.6796 22.9594 22.6702 23.0354 22.6759C23.1114 22.6816 23.1855 22.7022 23.2535 22.7366C23.3216 22.7709 23.3822 22.8183 23.4319 22.8761L23.7455 23.2405C23.7952 23.2983 23.8558 23.3457 23.9238 23.38C23.9919 23.4144 24.066 23.435 24.142 23.4407C24.218 23.4464 24.2943 23.437 24.3667 23.4132C24.4391 23.3894 24.5061 23.3515 24.5638 23.3018L24.9283 22.9887C25.0449 22.8882 25.1966 22.8382 25.35 22.8496C25.5035 22.861 25.6461 22.9329 25.7466 23.0495L26.1229 23.4605C26.1725 23.5185 26.2329 23.5661 26.3008 23.6008C26.3687 23.6354 26.4428 23.6562 26.5188 23.6622C26.5948 23.6681 26.6712 23.6591 26.7437 23.6355C26.8162 23.6119 26.8833 23.5743 26.9412 23.5247L27.3057 23.2115C27.3635 23.1618 27.4305 23.124 27.5028 23.1002C27.5752 23.0763 27.6516 23.067 27.7276 23.0727C27.8035 23.0784 27.8777 23.099 27.9457 23.1334C28.0137 23.1677 28.0743 23.2151 28.124 23.2728L28.5237 23.72"
          stroke="#453924"
          strokeWidth="0.48"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_8"
          d="M18.0762 17.3878L18.7315 18.1339L20.8494 16.0083"
          stroke="#453924"
          strokeWidth="0.48"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_9"
          d="M21.5625 17.8697L21.8761 18.2342C21.9256 18.2921 21.9861 18.3396 22.054 18.3741C22.1219 18.4086 22.196 18.4294 22.2719 18.4353C22.3479 18.4412 22.4242 18.432 22.4966 18.4083C22.5691 18.3847 22.6361 18.347 22.694 18.2974L23.0584 17.9842C23.1751 17.8838 23.327 17.8339 23.4805 17.8454C23.634 17.8569 23.7767 17.9289 23.8772 18.0455L24.1904 18.41C24.2401 18.4678 24.3007 18.5152 24.3687 18.5495C24.4367 18.5839 24.5108 18.6045 24.5868 18.6102C24.6628 18.6159 24.7392 18.6065 24.8115 18.5827C24.8839 18.5589 24.9509 18.5211 25.0087 18.4713L25.3731 18.1582C25.4309 18.1084 25.4979 18.0706 25.5702 18.0468C25.6426 18.023 25.719 18.0136 25.795 18.0193C25.8709 18.025 25.9451 18.0456 26.0131 18.08C26.0811 18.1143 26.1417 18.1617 26.1914 18.2195L26.5678 18.6305C26.6174 18.6884 26.6779 18.7359 26.746 18.7703C26.814 18.8047 26.8881 18.8254 26.9641 18.8311C27.0401 18.8368 27.1165 18.8275 27.1889 18.8037C27.2613 18.7799 27.3283 18.742 27.3861 18.6923L27.7506 18.3786C27.8083 18.3289 27.8753 18.2911 27.9477 18.2673C28.0201 18.2434 28.0965 18.2341 28.1725 18.2399C28.2485 18.2456 28.3226 18.2663 28.3906 18.3007C28.4587 18.3351 28.5192 18.3826 28.5688 18.4404L28.969 18.8871"
          stroke="#453924"
          strokeWidth="0.48"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_10"
          d="M17.1602 27.3676L17.8155 28.1141L19.9334 25.9885"
          stroke="#453924"
          strokeWidth="0.48"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_11"
          d="M20.6719 27.5874L20.9855 27.9514C21.0351 28.0093 21.0956 28.0567 21.1636 28.0911C21.2316 28.1256 21.3056 28.1463 21.3816 28.152C21.4576 28.1577 21.5339 28.1484 21.6063 28.1246C21.6786 28.1008 21.7456 28.0629 21.8033 28.0132L22.1678 27.6996C22.2256 27.6498 22.2926 27.6119 22.3651 27.5881C22.4375 27.5643 22.5139 27.555 22.59 27.5607C22.6661 27.5665 22.7402 27.5871 22.8083 27.6216C22.8763 27.656 22.9369 27.7035 22.9866 27.7613L23.2997 28.1253C23.3493 28.1832 23.4099 28.2307 23.4779 28.2651C23.5459 28.2995 23.6201 28.3202 23.696 28.3259C23.7721 28.3317 23.8484 28.3224 23.9209 28.2986C23.9933 28.2747 24.0603 28.2369 24.118 28.1871L24.4825 27.8735C24.5402 27.8238 24.6072 27.7859 24.6797 27.7621C24.7521 27.7382 24.8285 27.729 24.9045 27.7347C24.9805 27.7404 25.0546 27.7611 25.1226 27.7955C25.1906 27.83 25.2512 27.8774 25.3008 27.9353"
          stroke="#453924"
          strokeWidth="0.48"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>,
  ],
});
